import axios from "axios";
import { Eprezto_Settings } from "../settings";

let API_URL = Eprezto_Settings.LOCAL_MODE
  ? "http://localhost:3000"
  : "https://api-colombia.eprezto.com";

export const setReferralView = async (linkId) => {
  let data = {
    linkId: linkId,
    referralSource: document.referrer || "direct",
  };

  try {
    let view = await axios.post(
      `${API_URL}/referral/get-quotation-data/`,
      data
    );
    return view.data;
  } catch (e) {
    console.log("error", e);
  }
};

export const saveRenewDataResponse = async (linkId) => {
  let data = {
    linkId: linkId,
    referralSource: document.referrer || "direct",
  };

  try {
    let view = await axios.post(
      `${API_URL}/referral/get-quotation-data/`,
      data
    );
    return view.data;
  } catch (e) {
    console.log("error", e);
  }
};

export const renewPolicyCall = async (transactionId) =>{

  let policyUrl = Eprezto_Settings.DEVELOPMENT_MODE
    ? /* ? `http://localhost:3001/api/dev/general_tools_rest/confirm_renew_link/${transactionId}` */
    `https://apollo.eprezto.com/api/dev/general_tools_rest/confirm_renew_link/${transactionId}`
    : `https://apollo.eprezto.com/api/prod/general_tools_rest/confirm_renew_link/${transactionId}`;

    if(Eprezto_Settings && Eprezto_Settings.LOCAL_MODE === true){
      policyUrl = `http://localhost:3001/api/dev/general_tools_rest/confirm_renew_link/${transactionId}`;
    }

    let renewedData = await axios
    .get(policyUrl)
    .then((res) => {      
      return res.data
    })
    .catch((e) => {      
      return e
    });

    return renewedData
}
